import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import CardField from './CardField';
import styles from './CardField.scss';

export default class CardInput extends React.Component {

  static propTypes = {
    children: PropTypes.node
  }

  render() {
    const _rest = _.omit(this.props, 'label', 'children');
    return (
      <CardField {...this.props}>
        <div className={`ui input transparent fluid ${styles.input}`}>
          {this.props.children &&
            React.cloneElement(this.props.children, {
              ..._rest
            })
          }
          {!this.props.children &&
            <input
              {..._rest}
            />
          }
        </div>
      </CardField>
    );
  }

}



// WEBPACK FOOTER //
// ./webpack/components/Elements/CardField/CardInput.js